import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function SsoCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) {
      navigate("/login");
      return;
    }
    localStorage.setItem("enfleet_token", token);
    api.get("/auth/me")
      .then((r) => {
        login(token, r.data);
        toast.success("Log masuk MyDigital ID berjaya");
        navigate("/");
      })
      .catch(() => {
        localStorage.removeItem("enfleet_token");
        toast.error("Token SSO tidak sah");
        navigate("/login");
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="sso-callback-page">
      <p className="text-sm text-muted-foreground">Melengkapkan log masuk MyDigital ID...</p>
    </div>
  );
}
